/**
 * bcrypt tylko na żądanie (dynamic import) — unikamy crashu przy starcie panelu (brak crypto w webpack 5).
 * Przy logowaniu przez admin-login.php (proxy) te funkcje nie są wywoływane.
 */
const BCRYPT_ROUNDS = 10;

let bcryptPromise = null;

function loadBcrypt() {
  if (!bcryptPromise) {
    bcryptPromise = import('bcryptjs').then((mod) => mod.default || mod);
  }
  return bcryptPromise;
}

export async function hashPassword(plainPassword) {
  const normalized = (plainPassword ?? '').trim();
  if (!normalized) {
    throw new Error('Hasło nie może być puste');
  }
  const bcrypt = await loadBcrypt();
  return bcrypt.hashSync(normalized, BCRYPT_ROUNDS);
}

export async function verifyPassword(plainPassword, storedHash) {
  if (!plainPassword || !storedHash) return false;
  const password = plainPassword.trim();
  const hash = String(storedHash).trim();
  if (!hash) return false;
  try {
    const bcrypt = await loadBcrypt();
    return await bcrypt.compare(password, hash);
  } catch {
    return false;
  }
}
